module.exports = __webpack_public_path__ + "static/media/NY_map@2x.eb73a441.png";